import { combineReducers } from "redux";
import GlobalReducer from "./GlobalReducer";

export default combineReducers({
  GlobalReducer: GlobalReducer,
});
